import React from 'react';

function ProfilePage() {
  return <div>This is the profile page</div>;
}

export default ProfilePage;
